import {
    getData,
} from './Services'

export const getLocalidades = async (id) => {
    const res = await getData(`/departamentos/departamentos_localidades/${id}`);
    const data = res.sus_localidades || [];  
    const localidadesTransformadas = data
        .filter(p => p.loc_descripcion) // filtra los nulos
        .map(p => {
            const descripcion = p.loc_descripcion.toLowerCase()
                .replace(/\b\w/g, l => l.toUpperCase()); // Capitaliza cada palabra
            return {
                id: p.id,
                value: descripcion,
                label: descripcion
            };
        });
    return localidadesTransformadas
}
